import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

type State = {
  hasError: boolean;
  message: string;
};

export class ModuleErrorBoundary extends React.Component<
  React.PropsWithChildren<{ moduleName: string }>,
  State
> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : String(error),
    };
  }

  componentDidUpdate(prevProps: Readonly<React.PropsWithChildren<{ moduleName: string }>>) {
    if (prevProps.moduleName !== this.props.moduleName && this.state.hasError) {
      this.setState({ hasError: false, message: '' });
    }
  }

  componentDidCatch(error: unknown) {
    console.error(`Elite Coach Cloud module error [${this.props.moduleName}]:`, error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <section className="metal-card module-recovery-card">
        <AlertTriangle size={30} />
        <p className="eyebrow">MODULE RECOVERY</p>
        <h2>{this.props.moduleName}</h2>
        <p>
          This section encountered a runtime error. The rest of Elite Coach Cloud remains available.
        </p>
        <code>{this.state.message || 'Unknown module error'}</code>
        <button
          type="button"
          className="gold-button"
          onClick={() => this.setState({ hasError: false, message: '' })}
        >
          <RefreshCw size={16} />
          Retry section
        </button>
      </section>
    );
  }
}
